"use client";

import { useEffect } from "react";

import { initializeAuth } from "@/shared/model/auth-store";
import { ActivityStatusSync } from "@/shared/providers/activity-status-sync";
import { NotificationConnectionProvider } from "@/shared/providers/notification-connection";
import { PresenceConnection } from "@/shared/providers/presence-connection";

export function AuthProvider({ children }: { children: React.ReactNode }) {
  // KAN-591: именно useEffect, не useLayoutEffect. initializeAuth синхронно
  // выставляет isAuthenticated по AUTH_HINT из sessionStorage, а от этого флага
  // зависит разметка шапки. Layout-эффект выполняется в фазе коммита, и при
  // выборочной гидратации React 18 успевал перерисовать шапку новым состоянием
  // раньше, чем догидратировался её кусок дерева, — сервер отдал гостевой
  // вариант, клиент нарисовал авторизованный, и это ловилось как ошибка 418 на
  // страницах с общей шапкой (/ и /rosters). Пассивный эффект ждёт конца
  // гидратации; цена — один кадр гостевой шапки у вернувшегося пользователя.
  useEffect(() => {
    initializeAuth();
  }, []);

  return (
    <NotificationConnectionProvider>
      <PresenceConnection />
      <ActivityStatusSync />
      {children}
    </NotificationConnectionProvider>
  );
}
